import { StoryblokServerComponent, storyblokEditable } from '@storyblok/react/rsc'
import Frame from '@/components/storyblok/global/Frame'
import PressHero from '@/components/press/PressHero'
import ShareArticle from '@/components/misc/ShareArticle'
import PressFooter from '@/components/press/PressFooter'

const Press = async ({ blok, rels, fullSlug }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <Frame blok={blok?.frame?.content} rels={rels}>
        <PressHero title={blok?.title} publishedDate={blok?.published_date} />
        {blok?.body?.map((currentSection, index) => (
          <StoryblokServerComponent
            blok={currentSection}
            key={currentSection?._uid}
            rels={rels}
            headingLevel={2}
            imagePriority={index === 0}
            lowerHeadingStyles
          />
        ))}
        <ShareArticle fullSlug={fullSlug} />
        <PressFooter />
      </Frame>
    </div>
  )
}

export default Press
